import React, { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { stores } from "mobx-store";
import { PredictionView } from "mobx-store/stores/afconStore";
import StateFullContainer from "components/stateFullContainer";


export const PredictionsTable: React.FC = observer(() => {
  const { matchId } = useParams<{ matchId: string }>();
  const { afconStore } = stores;

  useEffect(() => {
    if (matchId) {
      afconStore.fetchPredictionsByMatch(Number(matchId));
    }
  }, [matchId]);

  const predictions: PredictionView[] =
    afconStore.predictionsByMatch[Number(matchId)] || [];

  return (
    <Container>
      <Box style={{ marginBottom: 16, justifyContent: 'space-between', display: 'flex' }}>
        <Typography variant="h5">Predictions</Typography>
        <StateFullContainer state={afconStore.predictionsLoadState}>
          <Button color="primary" variant="contained" onClick={() => afconStore.downloadPredictionsXlsx(Number(matchId))}>Download</Button>
        </StateFullContainer>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Membership</TableCell>
              <TableCell>User Email</TableCell>
              <TableCell>Prediction</TableCell>
              <TableCell>Actual Result</TableCell>
              <TableCell>Correct?</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StateFullContainer state={afconStore.predictionsLoadState}>
              <>
                {predictions.length > 0 ? (
              predictions.map((p) => (
                <TableRow key={p.prediction_id}>
                  <TableCell>{p.membershipId}</TableCell>
                  <TableCell>{p.email}</TableCell>
                  <TableCell>
                    {p.predHomeGoals} - {p.predAwayGoals}{" "}
                    {p.predHomePenaltyGoals != null &&
                      p.predAwayPenaltyGoals != null && (
                        <>({p.predHomePenaltyGoals}-{p.predAwayPenaltyGoals})</>
                      )}
                  </TableCell>
                  <TableCell>
                    {p.homeGoals} - {p.awayGoals}{" "}
                    {p.homePenaltyGoals != null && p.awayPenaltyGoals != null && (
                      <>({p.homePenaltyGoals}-{p.awayPenaltyGoals})</>
                    )}
                  </TableCell>
                  <TableCell>
                    {p.isCorrect === 1 ? "✅" : p.isIncorrect === 1 ? "❌" : "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No predictions yet
                </TableCell>
              </TableRow>
            )}
              </>
            </StateFullContainer>

          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
});

export default PredictionsTable;
